import * as views from './pages'

angular.module('app.cessao').config(function ($stateProvider, lazyLoadProvider) {
    $stateProvider
        .state('app.cessao', {
            abstract: true
        })
        .state('app.cessao.integracaoporcallbackenvio', {
            url: '/bos/registradora/cessaoporcallback/enviocessao',
            views: {
                'content@app': lazyLoadProvider.create(views.integracaoCessaoPorCallbackEnvio)
            },
            data: {
                title: 'Consulta Integração',
                access: { requiredPermissions: ['RemessaFundo', 'backoffice'] },
                breadcrumbs: ['BOS', 'Cessão por Callback', 'Consulta Integração']
            }
        })
        .state('app.cessao.cessaohub', {
            url: '/bos/cessaohub?codigo&passo',
            views: {
                'content@app': lazyLoadProvider.create(views.cessaoHub)
            },
            data: {
                title: 'Cessão Hub',
                access: { requiredPermissions: ['RemessaFundo', 'backoffice'] },
                breadcrumbs: ['BOS', 'Cessão Hub']
            }
        })
        .state('app.cessao.lastroconsulta', {
            url: '/processos/lastro/consulta',
            views: {
                'content@app': lazyLoadProvider.create(views.lastroConsulta)
            },
            data: {
                title: 'Consulta Lastro',
                access: { requiredPermissions: ['backoffice', 'consultafgts'] },
                breadcrumbs: ['Processos', 'Lastro', 'Consulta']
            }
        })
        .state('app.cessao.lastroreprocessamento', {
            url: '/processos/lastro/reprocessamento',
            views: {
                'content@app': lazyLoadProvider.create(views.lastroReprocessamento)
            },
            data: {
                title: 'Reprocessamento Lastro',
                access: { requiredPermissions: ['backoffice'] },
                breadcrumbs: ['Processos', 'Lastro', 'Reprocessamento']
            }
        })
        .state('app.cessao.registrocpr', {
            url: '/bos/registrocpr',
            views: {
                'content@app': lazyLoadProvider.create(views.registroCPR)
            },
            data: {
                title: 'Registro CPR',
                access: { requiredPermissions: ['backoffice'] },
                breadcrumbs: ['BOS', 'Registradoras', 'CPR', 'Registro']
            }
        })
        .state('app.cessao.vendacpr', {
            url: '/bos/vendacpr',
            views: {
                'content@app': lazyLoadProvider.create(views.vendaCPR)
            },
            data: {
                title: 'Venda CPR',
                access: { requiredPermissions: ['backoffice'] },
                breadcrumbs: ['BOS', 'Registradoras', 'CPR', 'Venda']
            }
        })
        .state('app.cessao.cetipautomaticoconsulta', {
            url: '/bos/cetipautomaticoconsulta',
            views: {
                'content@app': lazyLoadProvider.create(views.cetipAutomaticoConsulta)
            },
            data: {
                title: 'CETIP Automático Consulta',
                access: { requiredPermissions: ['PropostaFormalizacao', 'Gravame'] },
                breadcrumbs: ['BOS', 'Gravame', 'CETIP Automático', 'Consulta']
            }
        })
        .state('app.cessao.cetipautomaticohistorico', {
            url: '/bos/cetipautomaticohistorico',
            views: {
                'content@app': lazyLoadProvider.create(views.cetipAutomaticoHistorico)
            },
            data: {
                title: 'CETIP Automático Histórico',
                access: { requiredPermissions: ['PropostaFormalizacao', 'Gravame'] },
                breadcrumbs: ['BOS', 'Gravame', 'CETIP Automático', 'Histórico de Integração']
            }
        })
});